import React from 'react';
import { X, Sparkles } from 'lucide-react';

const WidgetSummary = ({ showSummary, summaryLoading, summaryError, summaryText, onClose }) => {
  if (!showSummary) return null;

  return (
    <div className="mb-3 rounded border border-secondary bg-secondaryLight overflow-hidden">
      {/* Header row */}
      <div className="flex items-center justify-between px-3 pt-2">
        <div className="flex items-center gap-1.5">
          <Sparkles size={12} className="text-secondary" />
          <span className="text-xs font-semibold text-secondary-700 uppercase tracking-wide">AI Insight</span>
        </div>
        <button
          onClick={onClose}
          className="text-secondary-300 hover:text-secondary-500 transition-colors rounded p-0.5 hover:bg-secondary-100"
          type="button"
          title="Dismiss"
        >
          <X size={13} />
        </button>
      </div>

      {/* Content */}
      <div className="px-3 py-2.5">
        {summaryLoading ? (
          <div className="flex items-center gap-2 py-1">
            <Sparkles size={12} className="text-secondary-400 animate-pulse shrink-0" />
            <span className="text-xs text-secondary-400 italic">Generating insight...</span>
          </div>
        ) : summaryError ? (
          <p className="text-xs text-red-500">{summaryError}</p>
        ) : (
          <div
            className="text-xs text-secondary-900 leading-relaxed"
            style={{ lineHeight: '1.65' }}
            dangerouslySetInnerHTML={{ __html: summaryText }}
          />
        )}
      </div>
    </div>
  );
};

export default WidgetSummary;
